/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../Containers/ArgosFlexbox';
import {IArgosReportSectionProps} from '../constants';
import Plot from 'react-plotly.js';
import React, { useEffect, useState } from 'react';


const BarPlot = (props: IArgosReportSectionProps) => {
  const plotData = props.data
  const [plottingObject, setPlottingObject] = useState<any>([])

  /**
   * Update plotting object when plotData changes
   */
  useEffect(() => {
    constructPlottingObject()
  }, [plotData])

  const constructPlottingObject = () => {
    let newPlotData: any = []
    if (plotData !== undefined) {
      newPlotData.push({
        x: plotData.xData,
        y: plotData.yData,
        type: 'bar',
      })
    }
    setPlottingObject(newPlotData)
  }

  return(
    <ArgosFlexbox style={{justifyContent: "center", padding: 10, paddingTop: 0}}>
      <Plot
        data={plottingObject}
        style={{height: 500, width: 500, paddingBottom: "3px"}}
        layout={{
          showlegend: false,
          title: plotData?.plotTitle ?? "",
          xaxis: {
            title: plotData?.xAxisLabel ?? "",
          },
          yaxis: {
            title: plotData?.yAxisLabel ?? "",
          },
        }}
      />
    </ArgosFlexbox>
  )
}

export default BarPlot
